
import RootReducer from './RootReducer'
import {combineReducers} from 'redux'

const rootReducer = combineReducers({
    RootReducer
})

export default rootReducer